export default __webpack_public_path__ + "static/add-a151e3c68bae47427afa5ac69adb2327.svg";